module.exports = __webpack_public_path__ + "static/img/gong3.7cb8ed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/gong3.png
// module id = V7A2
// module chunks = 44